import { ConsentCategory } from '../ConsentService';
import EventBusService from '../EventBusService';
import * as featureFlagService from '../FeatureFlagService';

import { BEAMER_BUTTON_ID } from './constants';

const initialize = () => {
  const elementId = 'changelog-js-sdk';
  if (window.document.getElementById(elementId)) {
    // Already loaded
    return;
  }

  const isBeamerEnabled = environment.BEAMER_ENABLED;
  if (!isBeamerEnabled) {
    return;
  }

  const localeToBeamerLocaleMap = {
    nl_BE: 'NB',
    fr_BE: 'FB',
  };

  const beamerConfigWithoutFeatureFlags = {
    selector: BEAMER_BUTTON_ID,
    product_id: 'HvZcFKme213',
    alert: false,
    language: localeToBeamerLocaleMap[window.top.TLGLOBALS.LOCALE] || window.top.TLGLOBALS.LANGUAGE,
    filter: window.top.__INITIAL_STATE__.user.accessibleModules.join(';'),
    callback: flyoutTrigger,
    onopen: onOpenTrigger,
    user_id: window.top.TLGLOBALS.EMPLOYEEID, // Beamer can only identify with the snakecased user_id property.
    accountId: window.top.TLGLOBALS.ACCOUNTID,
  };

  const featureFlagsForBeamer = Object.entries(featureFlagService.getAll()).reduce(
    (allFeatureFlags, [featureFlagKey, featureFlagValue]) => {
      if (typeof featureFlagValue === 'string') {
        // If the value is a string it's most probably a version we specify. Because Beamer only accepts boolean
        // values we can't pass a string, so let's pass an entry which has the version specified in the key
        // and as value 'true'.
        return Object.assign(allFeatureFlags, {
          [`${featureFlagKey}${featureFlagValue}`]: true,
        });
      }
      return Object.assign(allFeatureFlags, {
        [featureFlagKey]: featureFlagValue,
      });
    },
    {},
  );

  // This global variable is picked up by Beamer once the script is loaded, it only works with this notation, it should not be changed.
  window.top.beamer_config = Object.assign(beamerConfigWithoutFeatureFlags, featureFlagsForBeamer);

  const script = document.createElement('script');

  script.setAttribute('id', elementId);
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', 'https://app.getbeamer.com/js/beamer-embed.js');
  script.setAttribute('defer', 'defer');
  script.dataset.cookieconsent = ConsentCategory.Necessary;

  window.top.document.head.appendChild(script);
};

const show = () => {
  if (window.top.Beamer) {
    window.top.Beamer.show();

    return;
  }

  openTeamleaderBlog();
};

const openTeamleaderBlog = () => {
  window.open('https://www.teamleader.eu/blog', '_blank');
};

const flyoutTrigger = (posts) => {
  if (posts > 0) {
    EventBusService.dispatch('changelog.updated', { numberOfNewPosts: posts });
  }
};

const onOpenTrigger = () => {
  EventBusService.dispatch('changelog.updated', { numberOfNewPosts: 0 });
};

const ChangeLogService = {
  show,
  initialize,
};

export default ChangeLogService;
